export default {"src":"/bnb/_next/static/media/polygon.3148f10c.svg","height":10,"width":12};